globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Reviews = appCustomerSpace.Modals.Reviews || {};

appCustomerSpace.Modals.Reviews.MultipleReviewsRequests = (function(superClass) {

  utils.extend(MultipleReviewsRequests, superClass);

  function MultipleReviewsRequests() {
    return MultipleReviewsRequests.__super__.constructor.apply(this, arguments);
  }

  $.extend(MultipleReviewsRequests.prototype, {
    init: function() {
      var modal = this;
      var $modal = $('.modal');
      var $importContactsBtn = $modal.find('.import-multiple-reviews-requests-contacts-btn');
      var $excelFileInput = $modal.find('.multiple-reviews-requests-excel-file-input');

      $importContactsBtn.on('click', function(e) {
        e.preventDefault();
        $excelFileInput.trigger('click');
      });

      $excelFileInput.on('change', function() {
        var $input     = $(this);

        if($input.val() != undefined) {
          $importContactsBtn.hide();
          $input.show();
          $modal.find('.modal-submit-btn').removeAttr('disabled');
        }
      });

      $modal.on('click', '.modal-submit-btn', function(e) {
        e.preventDefault();
        appCustomerSpace.Loader().start({ $container: modal.$html.find('.modal-content') });
        var form = $modal.find('form')
        var url = form.attr('action');
        var $body = $('body');
        var $html = $body.find('.recipients-container');

        $.ajax({
          type: "POST",
          url: url,
          data: new FormData(form[0]),
          processData: false,
          contentType: false,
          success: function(data) {
            if (data.response == 1) {
              appCustomerSpace.Loader().stop();
              modal.close();

              $html.html(data.html);
              appCustomerSpace.LimitlessPlugins.Checkbox.init($html);
              appCustomerSpace.Modules.InputPhone.init($html);
              appCustomerSpace.Controllers.Reviews.RequestsController.init;

              if(data.contacts_count > 1) {
                $body.find('.sending-button-text').html("Envoyer les invitations");
              }

              $('.data-validation-checkbox-container').show().addClass('needs-verification');
            } else {
              alert("Aucun fichier importé");
            }
          }
        });
      })

      return MultipleReviewsRequests.__super__.init.apply(this, arguments);
    }
  });

  return MultipleReviewsRequests;

})(appCustomerSpace.Modal);
